import React from 'react'
import {
  CFView,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { orderPickupButton } from 'images'

const orderingUrl =
  process.env.REACT_APP_ENVIRONMENT === 'dev'
    ? 'https://demo.codefusion.tech/restaurants/ebisu/locations/ebisuLocation1'
    : 'https://order.codefusion.tech/restaurants/nqeoaepgw1d0XIULFk73/locations/PcCPpuqPbaOEZeLx9xHC'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFLink href={orderingUrl}>
          <CFView hover>
            <CFImage src={orderPickupButton} maxWidth="300px" alt="About" />
          </CFView>
        </CFLink>
      </MobileScreen>
      <DefaultScreen>
        <a href={orderingUrl}>
          <CFView hover>
            <CFImage src={orderPickupButton} maxWidth="300px" alt="About" />
          </CFView>
        </a>
      </DefaultScreen>
    </CFView>
  )
}
